var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rankValue)?_c('div',{staticClass:"player-rank"},[_c('span',{class:'--rank-' + _vm.rankValue},[_vm._v(_vm._s(_vm.rankValue))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }